import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { ResetUserPasswordRPC } from "./resetUserPasswordRPC";

export class ResetUserPasswordRPCClientImpl extends ResetUserPasswordRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: ResetUserPasswordRPC.Request): Promise<LeoRPCResult<ResetUserPasswordRPC.Response, ResetUserPasswordRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "profile/ResetUserPassword",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      ResetUserPasswordRPC.ResponseDTO,
      ResetUserPasswordRPC.Errors.ErrorsDTO,
      ResetUserPasswordRPC.Response,
      ResetUserPasswordRPC.Errors.Errors
    >(
      response,
      "profile/ResetUserPassword",
      ResetUserPasswordRPC.Response.fromDTO,
      ResetUserPasswordRPC.Errors.fromDTO
    );
  }
}
